
import addressAction from "./addressAction.vue"
import addressList from "./addressList.vue"
import storage from "@/utils/storage"
export default {
  name: "AddressComponent",
  components: {
    addressAction,
    addressList
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      handRequest: false,
      addressList: []
    }
  },
  computed: {},
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.initAddress()
        }
      },
      immediate: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    initAddress() {
      const accountInfo = storage.get("accountInfo", { useBase64: true }) || null
      if (accountInfo && accountInfo.address && accountInfo.address.length) {
        this.addressList = accountInfo.address
      } else {
        this.addressList = []
      }
    },
    handleClose() {
      this.$emit("close")
    },
    handleBack() {
      this.$emit("back")
    },

    handleAddressUpdate(param) {
      this.initAddress()
      this.$emit("back")
    }
  }
}
